<template>
  <section>

    <b-form inline>
      <b-form-input class="i-100" v-model="searchText" :placeholder="$t('SEARCH')"></b-form-input>
    </b-form>


    <div class="clearfix documentTitle">
      <div class="information w-light d-none d-lg-table-cell">
        <small>{{ $t('DOCUMENT.NAME') }}</small>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        <small>{{ $t('DCLIDENTITY') }}</small>
      </div>
      <div class="information w-light d-none d-lg-table-cell">
        <small>{{ $t('TEAM.TITLE') }}</small>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        <small>{{ $t('DOCUMENT.PUBLISHED') }}</small>
      </div>
    </div>

    <b-card no-body class="mt-2">
        <ledger-request-item v-for="item in items" :item="item" @click.native="showDetailed(item)" :key="item.request.id" />
    </b-card>

    <b-card v-if="items.length === 0" no-body>
      <b-card-body class="m-4">{{ $t('DOCUMENTS.NO_REQUESTS')}}</b-card-body>
    </b-card>
    
    <b-pagination
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
      align="center"
      @input="getRequests"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>

  </section>
</template>
<script>
import LedgerRequestItem from "@/components/Ledger/LedgerRequestItem";
export default {
  components: {
    LedgerRequestItem
  },
  data() {
    return {
      currentPage: 1,
      searchText: '',
      limit: 10,
      items: [],
      totalItems: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getRequests: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/documents/requests/list", {
          page: this.page,
          limit: this.limit,
          searchText: this.searchText
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  watch: {
    searchText: function() {
      if (this.searchText.length == 0) {
        this.getRequests();
      }
      if (this.searchText.length >= 3) {
        this.getRequests();
      }
    }
  },
  created: function() {
    this.getRequests();
  }
};
</script>
<style>
</style>
